// extracted by mini-css-extract-plugin
export default {"root":"CopilotStudioPage_root__+uxAg","frame":"CopilotStudioPage_frame__-pY8z","empty":"CopilotStudioPage_empty__i2pr4"};